/**
 * The methods in this file are used to display a meaningful subtitle for an admin's command
 * e.g. "Launch immediately" or "Launch when webhook is received"
 * The majority of this code has been taken from client/models/CommandModel.js and only been linted.
 * TODO: It might be useful to simplify this code at some point.
 * TODO: Tests have not been written for every function yet as they will most likely be refactored
 * when the command results section is refactored.
 */
/* eslint-disable radix */
import CronParser from 'client/Commands/CronParser';
import launchTypes from 'client/Commands/constants/LaunchTypes';
import moment from 'moment';

const containsCronExpression = (cronTab) => Object.keys(cronTab).length !== 0;

// We don't store the date for these "one-time" commands so they are actually yearly.
const getOneTimeSummary = (cronTab) => {
  try {
    if (!containsCronExpression(cronTab)) {
      return 'Not scheduled';
    }
    // Display the current year
    const year = moment().format('YYYY');
    const dateTime = `${cronTab.months[0].value}/${cronTab.days[0].value}/${year} ${cronTab.hours[0].value}:${cronTab.minutes[0].value}`;
    const dateTimeFormat = 'M/D/YYYY H:m';

    let readableDate = moment(dateTime, dateTimeFormat).format('dddd MMM Do YYYY');
    readableDate = `${readableDate}, at `;
    readableDate = `${readableDate}${moment(dateTime, dateTimeFormat).format('HH:mm')} (Server Time)`;
    return readableDate;
  } catch (e) {
    return 'unknown';
  }
};

const getRepeatedSummary = (cronTab, scheduleRepeatType) => {
  let summary = '';
  let repeatEvery;

  try {
    let cronTime;
    let cronDay;
    switch (scheduleRepeatType) {
      case 'minute':
        [{ repeatEvery }] = cronTab.minutes;
        summary = repeatEvery === 1 ? 'minute' : `${repeatEvery} minutes`;
        break;

      case 'hour':
        [{ repeatEvery }] = cronTab.hours;
        summary = repeatEvery === 1 ? 'hour' : `${repeatEvery} hours`;
        break;

      case 'day':
        [{ repeatEvery }] = cronTab.days;
        cronTime = moment(`${cronTab.hours[0].value}:${cronTab.minutes[0].value}`, 'H:m')
          .format('HH:mm');
        summary = repeatEvery === 1 ? 'day' : `${repeatEvery} days`;
        summary = `${summary} at ${cronTime} (Server Time)`;
        break;

      case 'week':
        if (cronTab.weekdays.Sunday && cronTab.weekdays.Monday && cronTab.weekdays.Tuesday
          && cronTab.weekdays.Wednesday && cronTab.weekdays.Thursday
          && cronTab.weekdays.Friday && cronTab.weekdays.Saturday) {
          summary = 'Day of the Week';
        } else if (!cronTab.weekdays.Sunday && cronTab.weekdays.Monday && cronTab.weekdays.Tuesday
          && cronTab.weekdays.Wednesday && cronTab.weekdays.Thursday
          && cronTab.weekdays.Friday && !cronTab.weekdays.Saturday) {
          summary = 'Weekday';
        } else if (cronTab.weekdays.Sunday && !cronTab.weekdays.Monday && !cronTab.weekdays.Tuesday
          && !cronTab.weekdays.Wednesday && !cronTab.weekdays.Thursday
          && !cronTab.weekdays.Friday && cronTab.weekdays.Saturday) {
          summary = 'Weekend';
        } else {
          const summaryArray = [];
          if (cronTab.weekdays.Sunday) summaryArray.push('Sun');
          if (cronTab.weekdays.Monday) summaryArray.push('Mon');
          if (cronTab.weekdays.Tuesday) summaryArray.push('Tue');
          if (cronTab.weekdays.Wednesday) summaryArray.push('Wed');
          if (cronTab.weekdays.Thursday) summaryArray.push('Thu');
          if (cronTab.weekdays.Friday) summaryArray.push('Fri');
          if (cronTab.weekdays.Saturday) summaryArray.push('Sat');

          for (let i = 0; i < summaryArray.length; i += 1) {
            summary += `${summaryArray[i]}, `;
          }

          summary = summary.replace(/, $/, '');
        }

        cronTime = moment(`${cronTab.hours[0].value}:${cronTab.minutes[0].value}`, 'H:m')
          .format('HH:mm');
        summary += ` at ${cronTime} (Server Time)`;
        break;

      case 'month':
        cronDay = moment(`${cronTab.months[0].value}/${cronTab.days[0].value}`, 'M/D')
          .format('MMM Do');
        cronTime = moment(`${cronTab.hours[0].value}:${cronTab.minutes[0].value}`, 'H:m')
          .format('HH:mm');
        summary = `${cronDay} at ${cronTime} (Server Time)`;
        break;

      case 'year':
        break;

      default:
        summary = cronTab;
        break;
    }
  } catch (e) {
    return scheduleRepeatType || 'unknown';
  }
  return summary;
};

export default {
  getLaunchSummaryText(item) {
    let prefix = '';
    let condition = '';
    let suffix = '';

    const {
      launchType,
      listensTo,
      schedule,
      scheduleRepeatType,
      trigger,
    } = item;

    let cronTab = {};
    if (schedule && schedule !== 'immediate' && schedule !== 'agentEvent') {
      cronTab = CronParser.parseCronTab(schedule);
    }

    switch (launchType) {
      case launchTypes.oneTime:
        prefix = containsCronExpression(cronTab) ? 'Launch on' : '';
        condition = getOneTimeSummary(cronTab);
        break;
      case launchTypes.repeated:
        prefix = 'Launch every';
        condition = getRepeatedSummary(cronTab, scheduleRepeatType);
        break;
      case launchTypes.trigger:
        prefix = 'Launch when';
        condition = trigger;
        suffix = 'is received';
        break;
      case launchTypes.addDeleteUser:
        prefix = 'Launch on';
        if (listensTo === 'AddUser') {
          condition = 'Add User';
        } else if (listensTo === 'DeleteUser') {
          condition = 'Delete User';
        }
        break;
      case launchTypes.everyLogin:
        prefix = 'Launch on';
        condition = 'every login';
        break;
      case launchTypes.nextLogin:
        prefix = 'Launch on';
        condition = 'next login';
        break;
      case launchTypes.nextRegistration:
        prefix = 'Launch on';
        condition = 'next registration';
        break;
      default:
        prefix = 'Launch';
        condition = 'Manually';
        break;
    }
    return `${prefix} ${condition} ${suffix}`;
  },
};
